import React, { useState } from 'react';

function ViewVendor({ vendor, closeModal }) {
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [showIdModal, setShowIdModal] = useState(false);

    if (!vendor) return null;

    function formatDateTime(isoString) {
        const date = new Date(isoString);
        const formattedDate = date.toLocaleDateString();
        const formattedTime = date.toLocaleTimeString();
        return { date: formattedDate, time: formattedTime };
    }

    const { date, time } = formatDateTime(vendor?.createdAt);

    return (
        <div className="modeldesignnew">
            <div className="overlaydesign"></div>
            <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="manufacturerModal">Details</h5>
                            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="vendor-container">
                                <div className="card shadow-sm border-0 rounded-3 mb-1">
                                    <div className="card-header">
                                        <h6 className=""><i className="bi bi-person-circle"></i> Customer Details</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6"><strong>Name:</strong> {vendor?.name}</div>
                                            <div className="col-md-6"><strong>Mobile No:</strong> {vendor?.mobileNo}</div>
                                            <div className="col-md-6"><strong>State:</strong> {vendor?.stateName}</div>
                                            <div className="col-md-6"><strong>City:</strong> {vendor?.cityName}</div>
                                            <div className="col-md-6"><strong>Address:</strong> {vendor?.address}</div>
                                            <div className="col-md-6"><strong>Registration Date:</strong> {date}</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card shadow-sm border-0 rounded-3 mb-1">
                                    <div className="card-header">
                                        <h6 className=""><i className="bi bi-person-circle"></i> SubCategory</h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-6"><strong>Name:</strong> {vendor?.subCategory?.title || "N/A"}</div>
                                        </div>
                                    </div>
                                </div>

                                {/* Bank Details */}
                               
                                    <div className="vendor-container mt-3">
                                        <div className="card shadow-sm border-0 rounded-3 mb-1">
                                            <div className="card-header">
                                                <h6 className=""><i className="bi bi-person-circle"></i>Bank Details</h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-6"><strong>Account No:</strong> {vendor?.accountNo}</div>
                                                    <div className="col-md-6"><strong>Bank Name:</strong> {vendor?.bankname}</div>
                                                    <div className="col-md-6"><strong>Account Holder:</strong> {vendor?.accountholdername}</div>
                                                    <div className="col-md-6"><strong>IFSC:</strong> {vendor?.ifsc}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                               
                                {/* Document Buttons */}
                                <div className="vendor-container mt-3">
                                        <div className="card shadow-sm border-0 rounded-3 mb-1">
                                            <div className="card-header">
                                                <h6 className=""><i className="bi bi-person-circle"></i>Document Details</h6>
                                            </div>
                                <div className="document-section mt-3 d-flex">
                                    <button className="document-update-btn me-2" onClick={() => setShowDocumentModal(true)}>
                                        <img src="img/label-img.svg" alt="Document" className="me-1" />
                                        View Document 1
                                    </button>
                                    <button className="document-update-btn" onClick={() => setShowIdModal(true)}>
                                        <img src="img/label-img.svg" alt="Pan/Aadhar" className="me-1" />
                                        View Document 2
                                    </button>
                                </div>
                                </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                {/* Document Modal */}
                {showDocumentModal && (
                    <div className="modal fade show d-block" id="imguploadModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Document</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowDocumentModal(false)} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <div className="container-box px-5">
                                        <div className="container-box-inner table-reponsive-tabe">
                                            <img
                                                src={vendor?.document ? `${process.env.REACT_APP_URL}${vendor?.document}` : 'img/default-doc.jpg'}
                                                alt="Document"
                                                style={{
                                                    width: '350px',
                                                    height: '220px',
                                                    display: 'block',
                                                    marginInline: 'auto'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Pan Card/Aadhar Card Modal */}
                {showIdModal && (
                    <div className="modal fade show d-block" id="imguploadpancardModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Pan Card/ Aadhar Card</h5>
                                    <button type="button" className="btn-close" onClick={() => setShowIdModal(false)} aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <div className="container-box px-5">
                                        <div className="container-box-inner table-reponsive-tabe">
                                            <img
                                                src={vendor?.idImage ? `${process.env.REACT_APP_URL}${vendor?.idImage}` : 'img/default-pan.jpg'}
                                                alt="Pan Card/ Aadhar Card"
                                                style={{
                                                    width: '350px',
                                                    height: '220px',
                                                    display: 'block',
                                                    marginInline: 'auto'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ViewVendor;
